import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ColumnOptions } from '@shared';
import { MenuEvent, MenuSelectEvent } from '@progress/kendo-angular-menu';
import {
  ExportOption,
  ImportOptions,
} from 'src/app/restaurant-item/restaurant-item/constants';
@Component({
  selector: 'app-grid-manager-toolbar',
  templateUrl: './grid-manager-toolbar.component.html',
  styleUrl: './grid-manager-toolbar.component.scss',
})
export class GridManagerToolbarComponent {
  fontSizePopupVisible: boolean = false;
  columnsPopupVisible: boolean = false;
  configurationDialogVisible: boolean = false;

  @Input()
  showConfig: boolean = false;

  @Input()
  showImport: ImportOptions[] = ['Current Type'];

  @Input()
  showExport: ExportOption[] = ['Current Type', 'Current Type (All Tiers)', 'All' ];

  @Input()
  fontSize: number = 0.875;

  @Input()
  view!: string;

  @Input()
  columns: ColumnOptions[] = [];

  @Input()
  importUrl!: Map<ImportOptions, string> | string;

  currentImportUrl?: string;

  @ViewChild('tools', { static: true })
  toolsTemplate!: TemplateRef<any>;

  @ViewChild('tableFontSize', { static: true })
  tableFontSizeTemplate!: TemplateRef<any>;

  @ViewChild('tableColumns', { static: true })
  tableColumnsTemplate!: TemplateRef<any>;

  @ContentChild('configurationTemplate', { static: true })
  configurationTemplate!: TemplateRef<any>;

  menuItems: any[] = [];

  selectedItem: string = '';

  @Output()
  fontSizeChange: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  exportToExcel: EventEmitter<ExportOption> = new EventEmitter<ExportOption>();

  @Output()
  uploadSuccessful: EventEmitter<void> = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges) {
    if (
      'showConfig' in changes ||
      'showImport' in changes ||
      'showExportAll' in changes ||
      'showViewExport' in changes
    ) {
      this.setupMenuItems();
    }
  }

  setupMenuItems() {
    this.menuItems = [
      {
        text: 'Tools',
        template: this.toolsTemplate,
        cssClass: 'tools-menu-root',
        items: [
          {
            text: 'Table Text Size',
            contentTemplate: this.tableFontSizeTemplate,
          },
          {
            text: 'Show/Hide Columns',
            contentTemplate: this.tableColumnsTemplate,
          },
        ],
      },
    ];

    if (this.showConfig) {
      this.menuItems[0].items.unshift({
        text: 'Delivery Settings',
        data: {
          callbackFunction: () => (this.configurationDialogVisible = true),
        },
      });
    }

    for (let option of this.showImport) {
      this.menuItems[0].items.push({
        text: `Import ${option}`,
        data: {
          callbackFunction: () => {
            if (this.importUrl instanceof Map && this.importUrl.has(option)) {
              this.currentImportUrl = this.importUrl.get(option);
            } else if (typeof this.importUrl === 'string') {
              this.currentImportUrl = this.importUrl;
            }
            this.uploadDialogVisible = true;
          },
        },
      });
    }
    for (let option of this.showExport) {
      this.menuItems[0].items.push({
        text: `Export ${option}`,
        data: {
          callbackFunction: () => this.exportToExcel.emit(option),
        },
      });
    }
  }

  uploadDialogVisible: boolean = false;
  changeFontSize(fontSize: number) {
    this.fontSizeChange.emit(fontSize);
  }

  onUploadComplete(event: any) {
    this.uploadSuccessful.emit();
  }

  onMenuSelect(event: MenuSelectEvent) {
    this.selectedItem = event.item.text;

    if (event.item.data?.callbackFunction) {
      event.item.data.callbackFunction();
    }
  }

  onMenuOpen(event: MenuEvent) {
    this.selectedItem = event.item.text;
  }

  onClose(event: MenuEvent) {
    if (this.selectedItem === 'Table Text Size') event.preventDefault();
  }
}
